<template>
  <div>
    <div
      :id="chartConfigObject.chartDivId"
      class="chartDiv"/>
      <!-- <div class="test">SPChartView</div> -->
      <!-- <div>
      {{ chartConfigObject }}

    </div>
    <div>
      {{ filteredData }}

    </div>
    <div>
      {{ lku }}
    </div> -->
  </div>
</template>

<!-- <style scoped>
  .chartDiv {
    width: 500px;
    margin-left: 10px;
    position: relative;
  }
</style> -->

<style>
    .chartDiv {
        /* width: 500px; */
        margin-left: 10px;
        margin-right: 10px;
        position: relative;
    }

    div.chartDiv h3 {
        /* margin: 0;
        padding: 0; */
    }

    div.chartDiv > * {
        font-family: Lato, Helvetica Neue, Helvetica, Arial, sans-serif;
        font-size: 14px;
    }

    div.chartDiv canvas {
        display: block;
        /* width: 100%; */
        visibility: hidden;

        /* For prototyping */
        outline: 2px dashed fuchsia;
    }

    div.chartDiv svg {
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
    }

    div.chartDiv .axis path,
    .axis line {
        fill: none;
        stroke: none;
    }
    div.chartDiv .grid line {
        stroke: darkgray;
        stroke-opacity: 0.7;
    }
    div.chartDiv .grid path {
        stroke-width: 0;
    }
    div.chartDiv .axis, .label {
        font-size: 14px;
    }
    div.chartDiv .confidence_indicator, .linecap_top, .linecap_bottom {
        stroke: black;
        stroke-width: 0.5;
    }
    div.chartDiv .legend_title {
        font-weight: bold;
    }
    div.chartDiv .tooltip {
      position: absolute;
      top: 0;
      left: 0;
      text-align: left;
      width: 200px;
      height: 140px;
      padding: 4px;
      font: 14px;
      line-height: 1.4em;
      background:#ededed;
      border: 1px solid #999999;
      border-radius: 4px;
      pointer-events: none;
      box-shadow: 2px 2px 1px gray;
      z-index: 5;
    }
    div.chartDiv .pathline {
        fill: none;
    }
    div.chartDiv .shadow {
        stroke: #bed2df;
        stroke-width: 5;
        z-index: 1;
    }
</style>

<script>
import _ from 'lodash';
import makeChart from './SPChart';


export default {
  name: 'SPChartView',
  props: {
    instance: {
      type: Number,
      default: 0,
    },
    chartConfigObject: {
      type: Object,
      default() {
        return {};
      },
    },
    filteredData: {
      type: Array,
      default() {
        return [];
      },
    },
    lku: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      chartDivWidth: 0,
    };
  },
  watch: {
    filteredData() {
      this.makeChart();
    },
    chartDivWidth() {
      // redraw chart if chartDivWidth has changed due to browser resize
      // https://forum.vuejs.org/t/vuejs-2-event-listener-window-resize/2526
      this.makeChartDebounce();
    },
  },
  created() {
    // define the debounce function in the created event instead of in a method
    // to get the chartDivWidth watch to update all SPChartView instances
    // instead of a single instance.
    // See: https://github.com/vuejs/vuejs.org/issues/1581
    this.makeChartDebounce =
      _.debounce(function fnToDebounce() {
        this.makeChart();
      }, process.env.DebounceDelay);
  },
  mounted() {
    this.makeChart();
    window.addEventListener('resize', this.getChartDivWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getChartDivWidth);
  },
  methods: {
    makeChart() {
      makeChart(this.chartConfigObject, this.filteredData, this.lku);
      this.getChartDivWidth();
    },
    getChartDivWidth() {
      this.chartDivWidth = document.getElementById(this.chartConfigObject.chartDivId).clientWidth;
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/components/SP/SPChartView.vue